import {
  makeStyles,
  Paper,
  Theme,
  createStyles,
  Typography,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import TicketsGrid from '../../components/Tickets/TicketsGrid';
import { APP_TITLE } from '../../utils/constants';
import { GetString } from '../../components/StringResourceManager';
import {
  LocaleInterface,
  locales,
} from '../../components/AlertsGrid/GridLocale';
import { ApplicationState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { formatDateToLocaleDateString } from '../../utils/utils';
import * as React from 'react';
import { Dispatch } from 'redux';
import {
  getTicketDivisionList,
  getTicketLaneNumbers,
  getTicketNodeGroups,
  getTicketNodeTypeList,
  getTicketStoreList,
} from '../../store/Tickets/TicketsActions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    dateTime: {
      textAlign: 'center',
      color: '#23496B',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 35,
    },
  }),
);

export default function TicketsMenu() {
  const classes = useStyles();

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage,
  );

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0],
  );
  const [lastRefresh, setLastRefresh] = React.useState<Date>(new Date());

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getTicketStoreList(dispatch);
      getTicketDivisionList(dispatch);
      getTicketLaneNumbers(dispatch);
      getTicketNodeGroups(dispatch);
      getTicketNodeTypeList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  const setLastRefreshQuery = (lastRefreshDate: Date) => {
    setLastRefresh(lastRefreshDate);
  };

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_TICKETS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_TICKETS')} />
      <Paper className={classes.paperGrid}>
        <TicketsGrid setLastRefreshQuery={setLastRefreshQuery} />
        <Typography color="textSecondary" className={classes.dateTime}>
          {GetString('LAST_REFRESH_DATETIME')}
          {formatDateToLocaleDateString(currentLocale.language, lastRefresh)}
        </Typography>
      </Paper>
    </>
  );
}
